export enum ScrollAnimationType {
  slideInLeft = 'slide-in-left',
  slideInRight = 'slide-in-right',
  slideInTop = 'slide-in-top',
  slideInBottom = 'slide-in-bottom',
  slideInBottomWithoutFade = 'slide-in-bottom-without-fade',
  scaleIn = 'scale-in',
  fadeIn = 'fade-in',
}
